import React, { FormEvent, RefObject, Component } from 'react'
import Button from 'tfs.button'

import NotificationInterface from '../../interfaces/client/Notification'

import getLabels from '../../utils/getLabels'
import doesFormContainValue from '../../utils/forms/doesFormContainValue'

import NewBookingFormRowHeader from '../../containers/NewBookingFormRowHeader'
import NewBookingFormComposeRows from '../../containers/NewBookingFormComposeRows'

import Notifications from '../Notifications'

import styles from './NewBookingForm.module.scss'

export interface NewBookingFormPropsInterface {
  removeNotification: Function
  removeNotifications: Function
  setIsFormSubmittable: Function
  setIsCSVUploadable: Function
  resetForm: Function
  handleSubmit: Function
  createRef: Function

  departureFlightId: string
  returnFlightId: string
  smartClassAllotmentCount: number
  economyAllotmentCount: number
  amountOfUploadedPassengers: number
  amountOfFormErrors: number
  errors: NotificationInterface[]
  notifications: NotificationInterface[]

  // Enhancement: reduce the amount of boolean values needed for this component
  isTOFlight: boolean
  formContainsNoError: boolean
  isBookingPassengers: boolean
  isFormSubmittable: boolean
  isResetFormButtonDisabled: boolean
  isCreateBookingButtonDisabled: boolean
}

export default class NewBookingForm extends Component<
  NewBookingFormPropsInterface
> {
  formRef: RefObject<HTMLFormElement> = this.props.createRef()

  private readonly _onSubmit = (event: FormEvent) => {
    const { handleSubmit, departureFlightId, returnFlightId } = this.props

    handleSubmit(event, [departureFlightId, returnFlightId])
  }

  private readonly _onChange = () => {
    const {
      formContainsNoError,
      setIsFormSubmittable,
      setIsCSVUploadable,
      isFormSubmittable,
    } = this.props

    if (!this.formRef.current || !this.formRef.current.elements) return

    const formContainsValue = Array.from(this.formRef.current.elements).find(
      doesFormContainValue
    )

    // TODO: move setIsFormSubmittable && setIsCSVUploadable to
    if (
      formContainsValue &&
      formContainsNoError &&
      isFormSubmittable === false
    ) {
      setIsFormSubmittable(true)
      setIsCSVUploadable(false)
    }

    if (!formContainsValue && isFormSubmittable === true) {
      setIsFormSubmittable(false)
      setIsCSVUploadable(true)
    }
  }

  private readonly _resetForm = (event: FormEvent<HTMLFormElement>) => {
    const {
      resetForm,
      departureFlightId,
      returnFlightId,
      setIsFormSubmittable,
    } = this.props

    resetForm(event, [departureFlightId, returnFlightId])
    this._onChange()

    setIsFormSubmittable(false)
  }

  // Improvement: move possible logic to container to simplify this component
  componentDidUpdate(prevProps: NewBookingFormPropsInterface) {
    if (!this.formRef.current || !this.formRef.current.elements) return
    const {
      formContainsNoError,
      amountOfUploadedPassengers,
      amountOfFormErrors,
      isBookingPassengers,
      setIsFormSubmittable,
      setIsCSVUploadable,
    } = this.props

    const formContainsValue = Array.from(this.formRef.current.elements).find(
      doesFormContainValue
    )

    // Starts server communication for booking passengers
    if (isBookingPassengers && !prevProps.isBookingPassengers) {
      setIsFormSubmittable(false)
      return
    }

    // Ends server communication for booking passengers
    if (
      !isBookingPassengers &&
      prevProps.isBookingPassengers &&
      amountOfFormErrors === 0 &&
      formContainsValue
    ) {
      setIsFormSubmittable(true)
      return
    }

    if (
      amountOfUploadedPassengers !== prevProps.amountOfUploadedPassengers ||
      amountOfFormErrors !== prevProps.amountOfFormErrors
    ) {
      const formIsSubmittable = Boolean(
        formContainsNoError && formContainsValue
      )

      setIsCSVUploadable(!formContainsValue)
      setIsFormSubmittable(formIsSubmittable)
    }
  }

  render() {
    const {
      isTOFlight,
      smartClassAllotmentCount,
      economyAllotmentCount,
      errors,
      notifications,
      removeNotification,
      removeNotifications,
      departureFlightId,
      isResetFormButtonDisabled,
      isCreateBookingButtonDisabled,
    } = this.props

    return (
      <form
        ref={this.formRef}
        onSubmit={this._onSubmit}
        onChange={this._onChange}
      >
        <div className={styles['form-fields-wrapper']}>
          <NewBookingFormRowHeader isTOFlight={isTOFlight} />

          {notifications.length || errors.length ? (
            <span className={styles['notifications']}>
              <Notifications
                notifications={notifications}
                type="success"
                removeNotification={removeNotification}
                clearNotifications={removeNotifications}
              />

              <Notifications
                notifications={errors}
                type="error"
                removeNotification={removeNotification}
                clearNotifications={removeNotifications}
              />
            </span>
          ) : null}

          <NewBookingFormComposeRows
            smartClassAllotmentCount={smartClassAllotmentCount}
            economyAllotmentCount={economyAllotmentCount}
            departureFlightId={departureFlightId}
            isTOFlight={isTOFlight}
          />
        </div>

        <div className={styles['submit-box-wrapper']}>
          <div className={styles['submit-wrapper']}>
            <Button
              color="white"
              data-element="new-booking"
              onClick={this._resetForm}
              isDisabled={isResetFormButtonDisabled}
            >
              {getLabels('reset_booking')}
            </Button>

            <Button
              type="submit"
              data-element="create-new-booking"
              isDisabled={isCreateBookingButtonDisabled}
            >
              {getLabels('create_booking')}
            </Button>
          </div>
        </div>
      </form>
    )
  }
}
